import { IRootScopeService, IScope } from "angular";
import { NewHomeExperienceService } from "@webapp/home/services/new-home-experience.service";
import { IProfile } from "@webapp/user-profile/models/user-profile.models";
import { UserProfileService } from "../user-profile.service";

interface IProfileThemeScope extends IScope {
  profile: IProfile;
  disallowNewHomeToggle: boolean;
}

export class ProfileThemeCtrl {
  public static $inject = ["$rootScope", "$scope", "UserProfileService", "NewHomeExperienceService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: IProfileThemeScope,
    private profileService: UserProfileService,
    private newHomeExperienceService: NewHomeExperienceService
  ) {
    this.init();
  }

  private init = () => {
    this.loadUser();
    this.subscribeForProfileUpdate();
    this.$scope.disallowNewHomeToggle = this.newHomeExperienceService.shouldDisallowTogglingNewHome();
  };

  private loadUser = () => {
    this.$scope.profile = this.profileService.getProfile();
  };

  private subscribeForProfileUpdate = () => {
    const removeUserProfileUpdatedListener = this.$rootScope.$on("userProfileUpdated", (evt, profile: IProfile) => {
      this.$scope.profile = profile;
    });

    this.$scope.$on("$destroy", removeUserProfileUpdatedListener);
  };
}
